import {
  TOGGLE_PROJECT,
  TOGGLE_UPLOAD_MANAGER,
  UPLOAD_INITIATED,
  UPLOAD_START_CALL,
  UPLOAD_START_CALL_SUCCESS,
  UPLOAD_START_CALL_FAIL,
  CHUNK,
  CHUNK_SUCCESS,
  CHUNK_FAIL,
  UPLOAD_END_CALL,
  UPLOAD_END_CALL_FAIL,
  UPLOAD_END_CALL_SUCCESS,
  UPLOAD_JOB_STATUS_CALL,
  UPLOAD_JOB_STATUS_CALL_SUCCESS,
  UPLOAD_JOB_STATUS_CALL_FAIL,
} from './actionType'
import { getUpdatedFailedFiles } from './helpers'

export const uploadState = {
  tcins: {},
  uploadingChunksCount: 0,
  showUploadManager: false,
  uploadingFilesCount: 0,
  completedFilesCount: 0,
  failedFilesCount: 0,
}

export default function uploads(state = uploadState, action = {}) {
  let file
  let initialFiles = {}
  let uploadingFiles = {}
  let project = {}
  let failedFiles = {}
  let successFiles = {}
  let {
    completedFilesCount = 0,
    failedFilesCount = 0,
    uploadingFilesCount = 0,
    tcins = {},
  } = state
  tcins = { ...tcins }
  switch (action.type) {
    case TOGGLE_UPLOAD_MANAGER:
      return {
        ...state,
        showUploadManager: !state.showUploadManager,
      }
    case UPLOAD_INITIATED:
      // eslint-disable-next-line no-case-declarations
      let selectedProject = tcins[action.project.project_uuid]
      if (selectedProject) {
        initialFiles = { ...selectedProject.initialFiles, ...action.files }
        uploadingFiles = { ...selectedProject.uploadingFiles }
        successFiles = { ...selectedProject.successFiles }
        failedFiles = { ...selectedProject.failedFiles }
      } else {
        initialFiles = action.files
      }
      tcins[action.project.project_uuid] = {
        project_name: action.project.project_name,
        project_uuid: action.project.project_uuid,
        initialFiles,
        uploadingFiles,
        successFiles,
        failedFiles,
        isExpanded: true,
      }
      return {
        ...state,
        tcins,
        showUploadManager: true,
      }
    case TOGGLE_PROJECT:
      tcins[action.projectUUID] = {
        ...tcins[action.projectUUID],
        isExpanded: !tcins[action.projectUUID].isExpanded,
      }
      return {
        ...state,
        tcins,
      }
    case UPLOAD_START_CALL:
      file = {
        ...tcins[action.projectUUID].initialFiles[action.fileName],
        uploadStatus: 'Not Started',
      }
      initialFiles = { ...tcins[action.projectUUID].initialFiles }
      delete initialFiles[action.fileName]
      uploadingFiles = {
        ...tcins[action.projectUUID].uploadingFiles,
        [action.fileName]: file,
      }
      project = {
        ...tcins[action.projectUUID],
        initialFiles,
        uploadingFiles,
      }
      tcins[action.projectUUID] = project
      uploadingFilesCount = uploadingFilesCount + 1
      return {
        ...state,
        tcins,
        uploadingFilesCount,
      }
    case UPLOAD_START_CALL_SUCCESS:
      file = {
        ...tcins[action.projectUUID].uploadingFiles[action.fileName],
        uploadStatus: 'In Progress',
      }
      uploadingFiles = {
        ...tcins[action.projectUUID].uploadingFiles,
        [action.fileName]: file,
      }
      project = { ...tcins[action.projectUUID], uploadingFiles }
      tcins[action.projectUUID] = project
      return {
        ...state,
        tcins,
      }
    case UPLOAD_START_CALL_FAIL:
      file = {
        ...tcins[action.projectUUID].uploadingFiles[action.fileName],
        uploadStatus: 'Failed',
      }
      uploadingFiles = { ...tcins[action.projectUUID].uploadingFiles }
      delete uploadingFiles[action.fileName]
      failedFiles = {
        ...tcins[action.projectUUID].failedFiles,
        [action.fileName]: file,
      }
      project = { ...tcins[action.projectUUID], uploadingFiles, failedFiles }
      tcins[action.projectUUID] = project
      uploadingFilesCount = Object.keys(uploadingFiles || {}).length
      failedFilesCount = Object.keys(failedFiles || {}).length
      return {
        ...state,
        tcins,
        uploadingFilesCount,
        failedFilesCount,
      }
    case CHUNK:
      return {
        ...state,
      }
    case CHUNK_SUCCESS:
      file = {
        ...tcins[action.projectUUID].uploadingFiles[action.fileName],
        completedChunks: action.completedChunks,
        totalChunks: action.totalChunks,
      }
      uploadingFiles = {
        ...tcins[action.projectUUID].uploadingFiles,
        [action.fileName]: file,
      }
      project = { ...tcins[action.projectUUID], uploadingFiles }
      tcins[action.projectUUID] = project
      return {
        ...state,
        tcins,
      }
    case CHUNK_FAIL:
      file = {
        ...tcins[action.projectUUID].uploadingFiles[action.fileName],
        name: action.fileName,
        uploadStatus: 'Failed',
      }
      uploadingFiles = { ...tcins[action.projectUUID].uploadingFiles }
      delete uploadingFiles[action.fileName]
      failedFiles = {
        ...tcins[action.projectUUID].failedFiles,
        [action.fileName]: file,
      }
      project = { ...tcins[action.projectUUID], uploadingFiles, failedFiles }
      tcins[action.projectUUID] = project
      uploadingFilesCount = Object.keys(uploadingFiles || {}).length
      failedFilesCount = Object.keys(failedFiles || {}).length
      return {
        ...state,
        tcins,
        uploadingFilesCount,
        failedFilesCount,
        failedFiles,
      }
    case UPLOAD_END_CALL:
      return {
        ...state,
      }
    case UPLOAD_END_CALL_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      let { updatedFailedFiles = [], updatedFailedFilesCount = Number(0) } =
        getUpdatedFailedFiles(
          tcins[action.projectUUID].failedFiles,
          action.fileName
        )
      project = {
        ...tcins[action.projectUUID],
        failedFiles: updatedFailedFiles,
      }
      tcins[action.projectUUID] = project
      return {
        ...state,
        failedFilesCount: updatedFailedFilesCount,
        tcins,
      }
    case UPLOAD_END_CALL_FAIL:
      file = {
        ...tcins[action.projectUUID].uploadingFiles[action.fileName],
        uploadStatus: 'Failed',
      }
      uploadingFiles = { ...tcins[action.projectUUID].uploadingFiles }
      delete uploadingFiles[action.fileName]
      failedFiles = {
        ...tcins[action.projectUUID].failedFiles,
        [action.fileName]: file,
      }
      project = { ...tcins[action.projectUUID], uploadingFiles, failedFiles }
      tcins[action.projectUUID] = project
      failedFilesCount = Object.keys(failedFiles || {}).length
      return {
        ...state,
        tcins,
        failedFilesCount,
      }
    case UPLOAD_JOB_STATUS_CALL:
      return {
        ...state,
      }
    case UPLOAD_JOB_STATUS_CALL_SUCCESS:
      file = {
        ...tcins[action.projectUUID].uploadingFiles[action.fileName],
        uploadStatus: action.vaultUploadStatus,
        uploadedVersion: action.uploadedVersion,
      }
      uploadingFiles = { ...tcins[action.projectUUID].uploadingFiles }
      delete uploadingFiles[action.fileName]
      project = { ...tcins[action.projectUUID], uploadingFiles }
      if (action.vaultUploadStatus !== 'ERROR') {
        successFiles = {
          ...tcins[action.projectUUID].successFiles,
          [action.fileName]: file,
        }
        let {
          updatedFailedFiles: modifiedFailedFiles,
          updatedFailedFilesCount: modifiedFailedFilesCount,
        } = getUpdatedFailedFiles(
          tcins[action.projectUUID].failedFiles,
          action.fileName
        )
        project = { ...project, failedFiles: modifiedFailedFiles, successFiles }
        failedFilesCount = modifiedFailedFilesCount
        completedFilesCount = completedFilesCount + 1
      }
      tcins[action.projectUUID] = project
      uploadingFilesCount =
        uploadingFilesCount > 0 ? uploadingFilesCount - 1 : 0
      return {
        ...state,
        tcins,
        uploadingFilesCount,
        completedFilesCount,
        failedFilesCount,
      }
    case UPLOAD_JOB_STATUS_CALL_FAIL:
      file = {
        ...tcins[action.projectUUID].uploadingFiles[action.fileName],
        uploadStatus: 'Failed',
        failure_reason: action.failure_reason || '',
      }
      uploadingFiles = { ...tcins[action.projectUUID].uploadingFiles }
      delete uploadingFiles[action.fileName]
      failedFiles = {
        ...tcins[action.projectUUID].failedFiles,
        [action.fileName]: file,
      }
      project = { ...tcins[action.projectUUID], uploadingFiles, failedFiles }
      tcins[action.projectUUID] = project
      uploadingFilesCount = Object.keys(uploadingFiles || {}).length
      failedFilesCount = Object.keys(failedFiles || {}).length
      return {
        ...state,
        tcins,
        uploadingFilesCount,
        failedFilesCount,
      }
    default:
      return state
  }
}
